import { Component, HostBinding } from '@angular/core'
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr'

@Component({
    selector: 'app-default-toast',
    templateUrl: './default-toast.component.html',
    styleUrls: ['./default-toast.component.scss'],
})
export class DefaultToastComponent extends Toast {
    @HostBinding('class.tap-to-dismiss') tapToDismiss: boolean

    constructor(toastrService: ToastrService, toastPackage: ToastPackage) {
        super(toastrService, toastPackage)
        this.tapToDismiss = this.toastPackage.config.tapToDismiss
    }
}
